import { createSelector } from 'reselect';

export const selectCompaniesSlice = state => state.companies;

export const selectCompanies = createSelector(
  selectCompaniesSlice,
  slice => slice.companies
);
export const companiesLoaded = createSelector(
  selectCompaniesSlice,
  slice => slice.companiesLoaded
);
export const selectActiveCompany = createSelector(
  selectCompaniesSlice,
  slice => slice.activeCompany
);

export const companiesMeta = createSelector(
  selectCompaniesSlice,
  slice => slice.meta
);
export const companiesFilters = createSelector(
  selectCompaniesSlice,
  slice => slice.filters
);

export const companiesCreating = createSelector(
  selectCompaniesSlice,
  slice => slice.isCreating
);
export const companiesUpdating = createSelector(
  selectCompaniesSlice,
  slice => slice.isUpdating
);
export const companiesDeleting = createSelector(
  selectCompaniesSlice,
  slice => slice.isDeleting
);
export const companiesErrors = createSelector(
  selectCompaniesSlice,
  slice => slice.errors
);
